import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreateDelivery from "../pages/Delivery/CreateDelivery";
import DeliveryList from "../pages/Delivery/DeliveryList";
import EditDelivery from "../pages/Delivery/EditDelivery";
import EditReceiveManifest from "../pages/Receive Manifest/EditReceiveManifest";
import ReceiveManifestlist from "../pages/Receive Manifest/ReceiveManifestlist";
import {
  AccessControl,
  PermissionRequired,
} from "@careinfo/permission-required";
export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path="/"
            element={
              <AccessControl
                children={<ReceiveManifestlist />}
                allowedPermissions={["can_view_manifest"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/manifest"
            element={
              <AccessControl
                children={<ReceiveManifestlist />}
                allowedPermissions={["can_view_manifest"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                children={<EditReceiveManifest />}
                allowedPermissions={["can_editupdate_manifest"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/runsheet"
            element={
              <AccessControl
                children={<DeliveryList />}
                allowedPermissions={["can_view_runsheet"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/runsheet/create"
            element={
              <AccessControl
                children={<CreateDelivery />}
                allowedPermissions={["can_create_runsheet"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/runsheet/edit/:id"
            element={
              <AccessControl
                children={<EditDelivery />}
                allowedPermissions={["can_editupdate_runsheet"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={1000} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
